module.exports = __webpack_public_path__ + "static/media/scheme-categories-ru.bb413d06.svg";